<template>
    <SvgAseLogo class="block w-10 h-10 md:w-12 md:h-12"
        role="img"
        alt="The Automotive Service Excellence logo" />
</template>

<script>
import SvgAseLogo from 'svg/ase-logo.svg';

export default {
    components: { SvgAseLogo }
};
</script>
